/**
 * Yönetim paneli giriş noktası.
 *
 * Kasadan farklı olarak burada offline-first bir strateji YOKTUR: panel
 * masaüstünde, akşam, çevrimiçi bakılır. Buna karşılık KK-539/KK-540 gereği
 * İSTEK CİMRİLİĞİ vardır — açık unutulmuş bir gösterge sekmesi, teneffüs
 * pikinde satış trafiğiyle aynı havuzu dövmemelidir.
 */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// HesapSis yazı tipleri yerel paketten yüklenir; mono tutar ve kodlarda kalır.
import "@fontsource-variable/hanken-grotesk";
import "@fontsource-variable/fraunces";
import "@fontsource-variable/jetbrains-mono";
import "./stiller.css";

import { Uygulama } from "./Uygulama.js";
import {
  oturumDurumu,
  platformOturumunuAl,
  temayiUygula,
} from "./veri/oturum.js";

// Tema ilk boyamadan ÖNCE uygulanır; aksi halde koyu temayı seçen kullanıcı
// her açılışta bir kare beyaz ekran görür.
temayiUygula(oturumDurumu.getState().tema);

const platformTokeni = new URLSearchParams(window.location.search).get(
  "platform_token",
);
if (platformTokeni) {
  try {
    platformOturumunuAl(platformTokeni);
  } finally {
    window.history.replaceState({}, "", window.location.pathname);
  }
}

const sorguIstemcisi = new QueryClient({
  defaultOptions: {
    queries: {
      // Yetki/404 reddi tekrar denemekle düzelmez; yalnızca bir kez denenir.
      retry: 1,
      // Sekmeye her dönüşte değil, veri bayatladığında çekilir.
      refetchOnWindowFocus: true,
      staleTime: 30_000,
      // Sekme arka plandayken canlı ekranlar da durur (KK-540).
      refetchIntervalInBackground: false,
    },
    mutations: { retry: 0 },
  },
});

createRoot(document.getElementById("kok")!).render(
  <StrictMode>
    <QueryClientProvider client={sorguIstemcisi}>
      <BrowserRouter>
        <Uygulama />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
